(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-cause-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gg-cause-page')) {
  customElements.define('gg-cause-page', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const media = this.querySelector('[data-ambient]');
      const video = media?.querySelector('video');
      const button = media?.querySelector('[data-ambient-toggle]');
      if (!video || !button) return;
      this.video = video;
      button.hidden = false;
      let manuallyPaused = false;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const play = () => {
        if (!video.src) video.src = window.matchMedia('(max-width:749px)').matches ? media.dataset.mobileUrl || media.dataset.desktopUrl : media.dataset.desktopUrl;
        video.play().catch(() => {});
      };
      const update = () => {
        const playing = !video.paused;
        media.classList.toggle('is-playing', playing);
        const label = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
        button.setAttribute('aria-label', label);
        button.querySelector('span').textContent = label;
      };
      button.addEventListener('click', () => { if (video.paused) { manuallyPaused = false; play(); } else { manuallyPaused = true; video.pause(); } });
      video.addEventListener('playing', () => { media.classList.add('has-video'); update(); });
      video.addEventListener('pause', update);
      video.addEventListener('error', () => { media.classList.remove('has-video'); button.hidden = true; });
      this.observer = new IntersectionObserver(entries => {
        if (!entries[0].isIntersecting) video.pause();
        else if (!motion.matches && !manuallyPaused && window.matchMedia('(min-width:750px)').matches) play();
      }, { threshold: .15 });
      this.observer.observe(media);
      this.visibilityHandler = () => { if (document.hidden) video.pause(); };
      document.addEventListener('visibilitychange', this.visibilityHandler);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.video?.pause(); document.removeEventListener('visibilitychange', this.visibilityHandler); }
  });
}
if (!customElements.get('gg-cause-film')) {
  customElements.define('gg-cause-film', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const cover = this.querySelector('[data-film-open]');
      const closeButton = this.querySelector('[data-film-close]');
      if (!cover || !closeButton) return;
      cover.addEventListener('click', event => {
        event.preventDefault();
        if (this.querySelector('iframe')) return;
        document.querySelectorAll('gg-cause-page video').forEach(video => video.pause());
        const frame = document.createElement('iframe');
        const url = new URL(cover.href);
        url.searchParams.set('autoPlay', 'true');
        frame.src = url.href;
        frame.title = this.dataset.title;
        frame.allow = 'autoplay; fullscreen; picture-in-picture';
        frame.allowFullscreen = true;
        this.append(frame);
        cover.hidden = true;
        closeButton.hidden = false;
        closeButton.focus();
      });
      closeButton.addEventListener('click', () => { this.querySelector('iframe')?.remove(); cover.hidden = false; closeButton.hidden = true; cover.focus(); });
      closeButton.addEventListener('keydown', event => { if (event.key === 'Escape') closeButton.click(); });
    }
    disconnectedCallback() { this.querySelector('iframe')?.remove(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-corporate-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gg-corporate-product')) {
  customElements.define('gg-corporate-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('[data-zoom]');
      let previousFocus;
      let previousOverflow;
      this.querySelectorAll('[data-zoom-src]').forEach(button => button.addEventListener('click', () => {
        const img = document.createElement('img');
        img.src = button.dataset.zoomSrc;
        img.alt = button.dataset.zoomAlt;
        dialog.querySelector('[data-zoom-image]').replaceChildren(img);
        previousFocus = button;
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }));
      dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow || '';
        dialog.querySelector('[data-zoom-image]').replaceChildren();
        previousFocus?.focus({ preventScroll: true });
      });
      const gallery = this.querySelector('[data-gallery]');
      const toggle = this.querySelector('[data-gallery-toggle]');
      if (toggle) {
        gallery.dataset.ready = '';
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          const expanded = gallery.toggleAttribute('data-expanded');
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? toggle.dataset.close : toggle.dataset.open;
        });
      }
      const variant = this.querySelector('[data-variant]');
      const updateVariant = () => {
        const selected = variant.selectedOptions[0];
        this.querySelector('[data-variant-price]').textContent = selected.dataset.price;
        const url = new URL(this.dataset.whatsappBase);
        url.searchParams.set('text', this.dataset.whatsappText + ' · ' + selected.textContent.trim());
        this.querySelector('[data-product-whatsapp]').href = url.href;
      };
      if (variant) { variant.addEventListener('change', updateVariant); updateVariant(); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-main-product"]) return;
  try {
    
if (!customElements.get('gg-product')) {
  customElements.define('gg-product', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.classList.add('is-enhanced');
      this.querySelector('[data-gg-variant-select]')?.setAttribute('tabindex', '-1');
      this.addEventListener('click', (event) => {
        const target = event.target.closest('button,a');
        if (!target) return;
        if (target.hasAttribute('data-gg-quantity')) {
          const input = this.querySelector('.ggpb input[name="quantity"]');
          target.dataset.ggQuantity === 'plus' ? input.stepUp() : input.stepDown();
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (target.hasAttribute('data-gg-variant')) { const select = this.querySelector('[data-gg-variant-select]'); select.value = target.dataset.ggVariant; select.dispatchEvent(new Event('change', { bubbles: true })); }
        if (target.hasAttribute('data-gg-sticky-buy')) { const form = this.querySelector('.ggpb__form'); const button = form?.querySelector('[name="add"]'); if (button && !button.disabled) form.requestSubmit(button); }
        if (target.matches('a[href="#GGProductCare"],a[href="#GGProductReturns"]')) { const detail = this.querySelector(target.getAttribute('href')); if (detail) detail.open = true; }
      });
      this.addEventListener('change', (event) => { if (event.target.matches('[data-gg-variant-select],[data-gg-plan]')) this.changeVariant(); });
      this.observePurchase();
      this.updateSticky();
      const info = this.querySelector('.ggp__info');
      this.infoObserver = new ResizeObserver(() => { this.style.setProperty('--gg-info-height', info.getBoundingClientRect().height + 'px'); });
      this.infoObserver.observe(info);
    }
    disconnectedCallback() { this.infoObserver?.disconnect(); this.observer?.disconnect(); this.controller?.abort(); this.ready = false; }
    observePurchase() {
      this.observer?.disconnect();
      this.observer = new IntersectionObserver((entries) => { const entry = entries[0]; this.querySelector('[data-gg-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, { threshold: 0 });
      const button = this.querySelector('.ggpb__add');
      if (button) this.observer.observe(button);
    }
    updateSticky() {
      const state = this.querySelector('[data-gg-buy]');
      this.querySelector('[data-gg-sticky-price]').textContent = state.dataset.priceText;
      const button = this.querySelector('[data-gg-sticky-buy]');
      const available = state.dataset.available === 'true';
      button.disabled = !available;
      button.replaceChildren(document.createTextNode(available ? this.dataset.addLabel : this.dataset.soldLabel));
      const bottle = state.querySelector('.ggpb__add .ggm-bottle'); if (bottle) button.append(bottle.cloneNode(true));
    }
    async changeVariant() {
      this.controller?.abort();
      const controller = new AbortController(); this.controller = controller;
      const oldBuy = this.querySelector('[data-gg-buy]');
      const variantInput = oldBuy.querySelector('[name="id"]');
      const planInput = oldBuy.querySelector('[name="selling_plan"]');
      const url = new URL(this.dataset.productUrl, location.origin);
      url.searchParams.set('variant', variantInput.value);
      if (planInput?.value) url.searchParams.set('selling_plan', planInput.value);
      const requestUrl = new URL(url); requestUrl.searchParams.set('section_id', this.dataset.section);
      const quantity = Number(oldBuy.querySelector('[name="quantity"]').value);
      oldBuy.setAttribute('aria-busy', 'true');
      oldBuy.querySelector('[name="add"]').disabled = true;
      this.querySelector('[data-gg-sticky-buy]').disabled = true;
      oldBuy.querySelector('[data-gg-buy-status]').textContent = this.dataset.loadingLabel;
      const timer = setTimeout(() => controller.abort('timeout'), 15000);
      try {
        const response = await fetch(requestUrl, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Product unavailable');
        const html = await response.text();
        if (controller.signal.aborted) return;
        const fragment = new DOMParser().parseFromString(html, 'text/html');
        const nextBuy = fragment.querySelector('[data-gg-buy]');
        if (!nextBuy) throw new Error('Product state unavailable');
        const input = nextBuy.querySelector('[name="quantity"]');
        const min = Number(input.min) || 1; const step = Number(input.step) || 1;
        input.value = String(Math.min(Number(input.max) || Infinity, Math.max(min, min + Math.floor((quantity - min) / step) * step)));
        oldBuy.replaceWith(nextBuy);
        nextBuy.querySelector('[data-gg-variant-select]')?.setAttribute('tabindex', '-1');
        if (nextBuy.dataset.variantMedia) this.querySelector('gg-product-gallery')?.showMedia(nextBuy.dataset.variantMedia);
        history.replaceState({}, '', url);
        this.updateSticky(); this.observePurchase();
        const currentButton = nextBuy.querySelector('[data-gg-variant][aria-pressed="true"]');
        currentButton?.focus({ preventScroll: true });
        nextBuy.querySelector('[data-gg-buy-status]').textContent = nextBuy.dataset.priceText;
        this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: JSON.parse(nextBuy.querySelector('[data-gg-variant-json]').textContent) } }));
      } catch (error) { if (!controller.signal.aborted || controller.signal.reason === 'timeout') location.assign(url); }
      finally { clearTimeout(timer); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-product-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gg-process-gallery')) customElements.define('gg-process-gallery',class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController(); const options = {signal:this.abort.signal};
    this.track = this.querySelector('.ggps__steps');
    this.cards = [...this.track.children];
    this.addEventListener('click',event => {
      const button = event.target.closest('[data-ggps-move]');
      if (!button) return;
      const first = this.cards[0]; const step = this.cards[1] ? this.cards[1].offsetLeft-first.offsetLeft : this.track.clientWidth;
      const target = Math.round(this.track.scrollLeft/step)*step+Number(button.dataset.ggpsMove)*step;
      this.track.scrollTo({left:target,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    },options);
    this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.sync());},{...options,passive:true});
    this.resize = new ResizeObserver(()=>this.sync());this.resize.observe(this.track);this.sync();
  }
  sync() {
    const max = this.track.scrollWidth-this.track.clientWidth;
    this.querySelector('[data-ggps-move="-1"]').disabled = this.track.scrollLeft<2;
    this.querySelector('[data-ggps-move="1"]').disabled = this.track.scrollLeft>=max-2;
    const left = this.track.getBoundingClientRect().left,right = left+this.track.clientWidth;
    const visible = this.cards.map((card,index)=>({rect:card.getBoundingClientRect(),index})).filter(({rect})=>rect.right>left+rect.width*.5&&rect.left<right-rect.width*.5);
    this.querySelector('[data-ggps-count]').textContent = visible.length ? `${visible[0].index+1}–${visible.at(-1).index+1} / ${this.cards.length}` : '';
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.resize?.disconnect();cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["green-glass-header-backup-20260929"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.underline = this.querySelector('#menu-hover--underline')
      this.menuLinks = this.querySelectorAll('.list-menu--inline > li .header__menu-item')
      this.modal = this.querySelector('.menu-drawer__modal')
      this.trigger = this.querySelector('.menu-drawer__subscription-link')
      this.closeModal = this.modal.querySelector('.menu-drawer__button')

      this.trigger.addEventListener('click', () => {
        this.modal.classList.toggle('active')
        this.trigger.setAttribute('aria-expanded', String(this.modal.classList.contains('active')))
      })

      this.closeModal.addEventListener('click', () => {
        if (this.modal.classList.contains('active')) {
          this.modal.classList.remove('active')
          this.trigger.setAttribute('aria-expanded', 'false')
        }
      })
      this.onHoverHandle()

      this.header = this.querySelector('.header')
      this.parentHeader = document.querySelector('sticky-header > .header')
      const menu = this.querySelector('.header__inline-menu')

      this.underline.addEventListener('transitionend', (e) => {
        if(this.underline.style.width === '0px') {
          this.underline.style.left = 0
        }
      })

    }

    onHoverHandle() {
      this.menuLinks.forEach((link, idx) => {
        link.addEventListener('mouseover', (e) => {
          this.trigger = link.closest('li')
          const elementWidth = e.target.offsetWidth
          const elementOffsetLeft = e.target.offsetLeft
          if(e.target == link) {
            this.underline.style.left = `${elementOffsetLeft}px`
            this.underline.style.width = `${elementWidth}px`
          }
          if (!link.hasMegaMenu) {
            if(this.parentHeader.openedMM) this.parentHeader.openedMM.hide()
          }
        })

        link.addEventListener('mouseleave', (e) => {
          if (!link.hasMegaMenu) {
            if(this.parentHeader.openedMM) this.parentHeader.openedMM.hide()
            this.hideUnderline()
          }
        })
      })
    }

    hideUnderline() {
      if(this.parentHeader.openedMM === undefined){
        this.trigger = undefined
        this.underline.style.width = 0
      }
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-green-glass-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.menuDrawer = this.querySelector('#menu-drawer')
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.querySelector('.gg-nav__details[open], .gg-search__dialog[open], #Details-menu-drawer-container[open]')) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.menuDrawer.classList.add('full-height')
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.menuDrawer.classList.remove('full-height')
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    } 
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["green-glass-header-backup-20261001-vertodo"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.underline = this.querySelector('#menu-hover--underline')
      this.menuLinks = this.querySelectorAll('.list-menu--inline > li .header__menu-item')
      this.modal = this.querySelector('.menu-drawer__modal')
      this.trigger = this.querySelector('.menu-drawer__subscription-link')
      this.closeModal = this.modal.querySelector('.menu-drawer__button')

      this.trigger.addEventListener('click', () => {
        this.modal.classList.toggle('active')
        this.trigger.setAttribute('aria-expanded', String(this.modal.classList.contains('active')))
      })

      this.closeModal.addEventListener('click', () => {
        if (this.modal.classList.contains('active')) {
          this.modal.classList.remove('active')
          this.trigger.setAttribute('aria-expanded', 'false')
        }
      })
      this.onHoverHandle()

      this.header = this.querySelector('.header')
      this.parentHeader = document.querySelector('sticky-header > .header')
      const menu = this.querySelector('.header__inline-menu')

      this.underline.addEventListener('transitionend', (e) => {
        if(this.underline.style.width === '0px') {
          this.underline.style.left = 0
        }
      })

    }

    onHoverHandle() {
      this.menuLinks.forEach((link, idx) => {
        link.addEventListener('mouseover', (e) => {
          this.trigger = link.closest('li')
          const elementWidth = e.target.offsetWidth
          const elementOffsetLeft = e.target.offsetLeft
          if(e.target == link) {
            this.underline.style.left = `${elementOffsetLeft}px`
            this.underline.style.width = `${elementWidth}px`
          }
          if (!link.hasMegaMenu) {
            if(this.parentHeader.openedMM) this.parentHeader.openedMM.hide()
          }
        })

        link.addEventListener('mouseleave', (e) => {
          if (!link.hasMegaMenu) {
            if(this.parentHeader.openedMM) this.parentHeader.openedMM.hide()
            this.hideUnderline()
          }
        })
      })
    }

    hideUnderline() {
      if(this.parentHeader.openedMM === undefined){
        this.trigger = undefined
        this.underline.style.width = 0
      }
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-green-glass-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.menuDrawer = this.querySelector('#menu-drawer')
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.querySelector('.gg-nav__details[open], .gg-search__dialog[open], #Details-menu-drawer-container[open]')) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.menuDrawer.classList.add('full-height')
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.menuDrawer.classList.remove('full-height')
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    } 
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["green-glass-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.underline = this.querySelector('#menu-hover--underline')
      this.menuLinks = this.querySelectorAll('.list-menu--inline > li .header__menu-item')
      this.modal = this.querySelector('.menu-drawer__modal')
      this.trigger = this.querySelector('.menu-drawer__subscription-link')
      this.closeModal = this.modal.querySelector('.menu-drawer__button')

      this.trigger.addEventListener('click', () => {
        this.modal.classList.toggle('active')
        this.trigger.setAttribute('aria-expanded', String(this.modal.classList.contains('active')))
      })

      this.closeModal.addEventListener('click', () => {
        if (this.modal.classList.contains('active')) {
          this.modal.classList.remove('active')
          this.trigger.setAttribute('aria-expanded', 'false')
        }
      })
      this.onHoverHandle()

      this.header = this.querySelector('.header')
      this.parentHeader = document.querySelector('sticky-header > .header')
      const menu = this.querySelector('.header__inline-menu')

      this.underline.addEventListener('transitionend', (e) => {
        if(this.underline.style.width === '0px') {
          this.underline.style.left = 0
        }
      })

    }

    onHoverHandle() {
      this.menuLinks.forEach((link, idx) => {
        link.addEventListener('mouseover', (e) => {
          this.trigger = link.closest('li')
          const elementWidth = e.target.offsetWidth
          const elementOffsetLeft = e.target.offsetLeft
          if(e.target == link) {
            this.underline.style.left = `${elementOffsetLeft}px`
            this.underline.style.width = `${elementWidth}px`
          }
          if (!link.hasMegaMenu) {
            if(this.parentHeader.openedMM) this.parentHeader.openedMM.hide()
          }
        })

        link.addEventListener('mouseleave', (e) => {
          if (!link.hasMegaMenu) {
            if(this.parentHeader.openedMM) this.parentHeader.openedMM.hide()
            this.hideUnderline()
          }
        })
      })
    }

    hideUnderline() {
      if(this.parentHeader.openedMM === undefined){
        this.trigger = undefined
        this.underline.style.width = 0
      }
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-green-glass-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.menuDrawer = this.querySelector('#menu-drawer')
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.querySelector('.gg-nav__details[open], .gg-search__dialog[open], #Details-menu-drawer-container[open]')) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.menuDrawer.classList.add('full-height')
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.menuDrawer.classList.remove('full-height')
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    } 
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haciendola-footer"]) return;
  try {
    
if (!customElements.get('gg-footer-links')) {
  customElements.define('gg-footer-links', class extends HTMLElement {
    connectedCallback() {
      this.breakpoint = matchMedia('(min-width:750px)');
      this.groups = [...this.querySelectorAll('.gg-footer__group')];
      this.update = () => this.groups.forEach(group => {
        group.open = this.breakpoint.matches;
        const summary = group.querySelector('summary');
        summary.tabIndex = this.breakpoint.matches ? -1 : 0;
      });
      this.breakpoint.addEventListener('change', this.update);
      this.update();
    }
    disconnectedCallback() { this.breakpoint?.removeEventListener('change', this.update); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.drawerMenu = this.querySelector('#menu-drawer');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
 
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.drawerMenu.classList.add('full-height')
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.drawerMenu.classList.remove('full-height')
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
